import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_2"
    preserveAspectRatio="true"
    fill="#000"
    style={{transform: 'scale(1.8)'}}
    data-name="Layer 2"
    viewBox="0 0 2050 2050"
    {...props}
  >
    <g id="SVGRepo_iconCarrier">
      <defs>
        <style>
          {
            ".cls-3{fill:#4d4c78}.cls-4{fill:#323150}.cls-5{fill:#f4c23f}.cls-6{fill:#f4a93f}.cls-7{fill:#de3226}.cls-8{fill:#b11a31}.cls-9{fill:#f8881b}.cls-11{fill:#fad564}.cls-12{fill:#f44533}"
          }
        </style>
      </defs>
      <title />
      <path
        d="M1025 193.6c-459.2 0-831.4 372.2-831.4 831.4s372.2 831.4 831.4 831.4 831.4-372.2 831.4-831.4-372.2-831.4-831.4-831.4Zm517.2 1342.3a730.5 730.5 0 0 1-232.5 154.9c-90.1 37.7-185.9 56.7-284.7 56.7s-194.6-19-284.7-56.7a730.5 730.5 0 0 1-232.5-154.9A721.4 721.4 0 0 1 351 1306.2a717.5 717.5 0 0 1 0-562.4 721.4 721.4 0 0 1 156.8-229.7 730.5 730.5 0 0 1 232.5-154.9c90.1-37.7 185.9-56.7 284.7-56.7s194.6 19 284.7 56.7a730.5 730.5 0 0 1 232.5 154.9A721.4 721.4 0 0 1 1699 743.8a717.5 717.5 0 0 1 0 562.4 721.4 721.4 0 0 1-156.8 229.7Z"
        style={{
          fill: "#67baeb",
        }}
      />
      <path
        d="M1025 246.9c-429.8 0-778.1 348.3-778.1 778.1s348.3 778.1 778.1 778.1 778.1-348.3 778.1-778.1-348.3-778.1-778.1-778.1Zm517.2 1289a730.5 730.5 0 0 1-232.5 154.9c-90.1 37.7-185.9 56.7-284.7 56.7s-194.6-19-284.7-56.7a730.5 730.5 0 0 1-232.5-154.9A721.4 721.4 0 0 1 351 1306.2a717.5 717.5 0 0 1 0-562.4 721.4 721.4 0 0 1 156.8-229.7 730.5 730.5 0 0 1 232.5-154.9c90.1-37.7 185.9-56.7 284.7-56.7s194.6 19 284.7 56.7a730.5 730.5 0 0 1 232.5 154.9A721.4 721.4 0 0 1 1699 743.8a717.5 717.5 0 0 1 0 562.4 721.4 721.4 0 0 1-156.8 229.7Z"
        style={{
          fill: "#46a1f8",
        }}
      />
      <rect
        width={95.4}
        height={299.55}
        x={977.3}
        y={82.5}
        className="cls-3"
        rx={47.7}
        ry={47.7}
      />
      <rect
        width={95.4}
        height={299.55}
        x={184.6}
        y={875.2}
        className="cls-3"
        rx={47.7}
        ry={47.7}
        transform="rotate(-90 232.3 1025)"
      />
      <rect
        width={95.4}
        height={299.55}
        x={977.3}
        y={1667.9}
        className="cls-3"
        rx={47.7}
        ry={47.7}
        transform="rotate(-180 1025 1817.7)"
      />
      <rect
        width={95.4}
        height={299.55}
        x={1770}
        y={875.2}
        className="cls-3"
        rx={47.7}
        ry={47.7}
        transform="rotate(90 1817.7 1025)"
      />
      <path
        d="M1050.9 355.4a47.7 47.7 0 0 1-47.7-47.7V103.6a47.1 47.1 0 0 1 3.2-17.3 47.7 47.7 0 0 0-29.1 43.9v204.1a47.7 47.7 0 0 0 47.7 47.8 47.8 47.8 0 0 0 44.5-30.5 47.9 47.9 0 0 1-18.6 3.8ZM360.2 1046H156.1a47.6 47.6 0 0 1-47.7-47.7 47.5 47.5 0 0 1 3.2-17.3 47.8 47.8 0 0 0-29.1 44 47.7 47.7 0 0 0 47.7 47.7h204.1a47.7 47.7 0 0 0 44.5-30.4 47.9 47.9 0 0 1-18.6 3.7ZM1050.9 1940.8a47.6 47.6 0 0 1-47.7-47.7V1689a47.5 47.5 0 0 1 3.2-17.3 47.8 47.8 0 0 0-29.1 44v204.1a47.7 47.7 0 0 0 47.7 47.7 47.7 47.7 0 0 0 44.5-30.4 47.9 47.9 0 0 1-18.6 3.7ZM1945.7 1046h-204.1a47.7 47.7 0 0 1-47.8-47.7 47.5 47.5 0 0 1 3.3-17.3 47.9 47.9 0 0 0-29.2 44 47.7 47.7 0 0 0 47.8 47.7h204.1a47.9 47.9 0 0 0 44.5-30.4 48.2 48.2 0 0 1-18.6 3.7Z"
        className="cls-4"
      />
      <path
        d="M1463.7 971c0 44.2-64.1 77.7-77 117.5-13.4 41.3 18.2 106-6.8 140.4s-96.7 24.4-131.4 49.7-46.6 96.3-87.9 109.7-91.4-37.1-135.6-37.1-95.7 50-135.6 37.1-53.5-84.7-87.9-109.7-106.1-15-131.4-49.7 6.6-99.1-6.8-140.4c-12.9-39.8-77-73.3-77-117.5s64.1-77.7 77-117.5-18.2-106 6.8-140.4 96.7-24.4 131.4-49.7 46.6-96.3 87.9-109.7 91.4 37.1 135.6 37.1 95.7-50 135.6-37.1 53.5 84.7 87.9 109.7 106.1 15 131.4 49.7-6.6 99.1 6.8 140.4 77 73.3 77 117.5Z"
        className="cls-5"
      />
      <path
        d="M1014.8 1285.3a287.3 287.3 0 0 1-264.4-398.7 288.9 288.9 0 0 1 61.5-91.2 287 287 0 1 1 202.9 489.9Z"
        className="cls-6"
      />
      <path
        d="M1196.7 1060.8a24 24 0 0 0-31.6-12L988.9 1128a25.7 25.7 0 0 0-6.6 4.5 25.7 25.7 0 0 0-6.6-4.5l-176.2-79.2a23.8 23.8 0 0 0-31.5 12l-81.9 182c32 18.4 86.5 14.7 115.4 35.8 33.3 24.2 45.8 91.7 84 108.2l96.8-215.3 85.9 191c32.2 13.9 65 34.7 92.4 25.8 41.3-13.4 53.5-84.7 87.9-109.7 10.4-7.6 24.3-12 39.2-15.4Z"
        className="cls-6"
      />
      <path
        d="m841.8 1486.3-41.8-73.8a23.7 23.7 0 0 0-25.7-11.6l-82.9 17.8c-19.2 4.1-34.8-15.3-26.8-33.1l146.1-324.8a23.8 23.8 0 0 1 31.5-12l176.2 79.2a24 24 0 0 1 12 31.6l-146.1 324.8c-8 17.8-32.9 18.9-42.5 1.9Z"
        className="cls-7"
      />
      <path
        d="M861.7 1120.4a49.4 49.4 0 0 0-24.1-65.5l-14-6.5a23.4 23.4 0 0 0-12.9 12.4l-146.1 324.8c-8 17.8 7.6 37.2 26.8 33.1l35.9-7.7Z"
        className="cls-8"
      />
      <path
        d="m1208.2 1486.3 41.8-73.8a23.7 23.7 0 0 1 25.7-11.6l82.9 17.8c19.2 4.1 34.8-15.3 26.8-33.1l-146.1-324.8a23.8 23.8 0 0 0-31.5-12l-176.2 79.2a24 24 0 0 0-12 31.6l146.1 324.8c8 17.8 32.9 18.9 42.5 1.9Z"
        className="cls-7"
      />
      <path
        d="m1077.5 1145.2-53.6 23.9 141.8 315.3c8 17.8 32.9 18.9 42.5 1.9l11.9-21Z"
        className="cls-8"
      />
      <path
        d="m1018.4 1128-176.2-79.2a23.8 23.8 0 0 0-31.5 12l-39.9 88.6a288.4 288.4 0 0 0 132.3 113.3 281.9 281.9 0 0 0 72 19.8l55.3-122.9a24 24 0 0 0-12-31.6Z"
        className="cls-8"
      />
      <path
        d="m1270.1 1129.3-30.8-68.5a23.8 23.8 0 0 0-31.5-12l-176.2 79.2a24 24 0 0 0-12 31.6l53.9 119.7a287.5 287.5 0 0 0 196.6-150Z"
        className="cls-8"
      />
      <circle cx={1025} cy={963.9} r={268.5} className="cls-9" />
      <circle
        cx={1025}
        cy={963.9}
        r={237.3}
        style={{
          fill: "#f08000",
        }}
      />
      <circle cx={1025} cy={963.9} r={210.6} className="cls-5" />
      <path
        d="M1212.5 653.6a49.8 49.8 0 0 0 15.1-13.7c-20.7-31.4-35.3-75.9-67-86.2-10.9-3.5-22.8-2.4-35 1.2a48.2 48.2 0 0 0 1 46.3l20 34.7a48.3 48.3 0 0 0 65.9 17.7ZM1026.1 606.6a48.3 48.3 0 0 0 6.8-16.3 71.3 71.3 0 0 1-7.9.5c-38.8 0-83.3-38.6-120.5-39.2a48.1 48.1 0 0 0 21.3 47l33.5 22a48.3 48.3 0 0 0 66.8-14ZM1386.7 853.5c-13.4-41.3 18.2-106-6.8-140.4-15.8-21.7-49.6-25.8-81.2-32a77.5 77.5 0 0 0-10.6 47.4l6.2 64.6a78.2 78.2 0 0 0 85.3 70.4 71.9 71.9 0 0 0 10.5-1.7 58 58 0 0 1-3.4-8.3Z"
        className="cls-11"
      />
      <rect
        width={71.4}
        height={135.98}
        x={861.5}
        y={1296.9}
        className="cls-12"
        rx={35.7}
        ry={35.7}
        transform="rotate(24.8 897.52 1365.897)"
      />
      <rect
        width={71.4}
        height={135.98}
        x={1261.1}
        y={1206.4}
        className="cls-12"
        rx={35.7}
        ry={35.7}
        transform="rotate(-24 1297.577 1274.98)"
      />
      <path
        d="m1028.2 849.5 28.1 56.9a15.5 15.5 0 0 0 11.6 8.4l62.8 9.1a15.4 15.4 0 0 1 8.5 26.2l-45.5 44.3a15.5 15.5 0 0 0-4.4 13.6l10.8 62.5a15.4 15.4 0 0 1-22.3 16.2l-56.2-29.5a15.1 15.1 0 0 0-14.3 0l-56.1 29.5a15.4 15.4 0 0 1-22.3-16.2l10.7-62.5a15.2 15.2 0 0 0-4.4-13.6l-45.4-44.3a15.4 15.4 0 0 1 8.5-26.2l62.8-9.1a15.2 15.2 0 0 0 11.5-8.4l28.1-56.9a15.3 15.3 0 0 1 27.5 0Z"
        className="cls-6"
      />
      <path
        d="m1037.6 848.8 25.8 52.3a14.5 14.5 0 0 0 10.6 7.7l57.8 8.4a14.1 14.1 0 0 1 7.8 24l-41.8 40.7a14.1 14.1 0 0 0-4 12.5l9.8 57.5a14 14 0 0 1-20.4 14.8l-51.6-27.1a14 14 0 0 0-13.2 0l-51.6 27.1a14 14 0 0 1-20.4-14.8l9.8-57.5a14.1 14.1 0 0 0-4-12.5l-41.8-40.7a14.1 14.1 0 0 1 7.8-24l57.8-8.4a14.5 14.5 0 0 0 10.6-7.7l25.8-52.3a14 14 0 0 1 25.2 0Z"
        className="cls-9"
      />
    </g>
  </svg>
)
export default SvgComponent
